import { extendTheme } from "@chakra-ui/react";
import "@fontsource/epilogue";
import "@fontsource/inter";

const theme = extendTheme({
  fonts: {
    heading: "'Epilogue', sans-serif",
    body: "'Inter', sans-serif",
  },
  colors: {
    "pt-bg": "#F6FAFD",
    "pt-blue": "#0168FF",
    "pt-navy": "#012D9B",
  },
});

export default theme;
